import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-input-with-operations',
  templateUrl: './input-with-operations.component.html',
  styleUrls: ['./input-with-operations.component.scss'],
})
export class InputWithOperationsComponent {
  @Input() public value = '';
  @Input() public withCopyButton = false;
  @Input() public withViewButton = false;
  @Input() public readonly = false;

  public hidden = !this.withViewButton;

  public showSecretClicked() {
    this.hidden = !this.hidden;
  }
}
